<template>
  <b-card>
    <!-- form -->
    <b-form>
      <b-row>
        <!-- bio -->
        <b-col cols="12">
          <b-form-group label="Terme de paiement" label-for="bio-area">
            <b-form-textarea
              id="bio-area"
              v-model="localOptions.paymentTerms"
              rows="4"
              placeholder="Terme de paiement..."
            />
          </b-form-group>
        </b-col>
        <!--/ bio -->

        <b-col sm="6">
          <b-form-group label="Compagnie" label-for="account-company">
            <b-form-input
              v-model="localOptions.company"
              name="company"
              placeholder="Compagnie"
            />
          </b-form-group>
        </b-col>
        <!-- Email -->
        <b-col md="6">
          <b-form-group
            label-for="example-datepicker"
            label="Email de la société"
          >
            <b-form-input
              v-model="localOptions.companyEmail"
              class="form-control"
              name="email"
              placeholder="Email"
            />
          </b-form-group>
        </b-col>
        <!--/ Email -->

        <!-- website -->
        <b-col md="6">
          <b-form-group label-for="fax" label="Fax">
            <b-form-input
              id="fax"
              v-model="localOptions.companyFax"
              placeholder="Fax"
            />
          </b-form-group>
        </b-col>
        <!--/ website -->

        <!-- phone -->
        <b-col md="6">
          <b-form-group label-for="phone" label="Téléphone">
            <cleave
              id="phone"
              v-model="localOptions.companyTel"
              class="form-control"
              :raw="false"
              :options="clevePhone"
              placeholder="Phone number"
            />
          </b-form-group>
        </b-col>
        <!-- phone -->

        <b-col md="12">
          <b-form-group label-for="Matricule" label="Matricule fiscale ">
            <b-form-input
              id="Matricule"
              v-model="localOptions.taxRegistrationNumber"
              placeholder="Matricule fiscale"
            />
          </b-form-group>
        </b-col>
        <!-- devis -->
        <!-- type de paiment -->
        <!-- Country -->
        <b-col md="6">
          <b-form-group label-for="countryList" label="Pays">
            <v-select
              id="countryList"
              v-model="localOptions.country"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="countryOption"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label-for="postal" label="Code postal">
            <b-form-input
              id="postal"
              v-model="localOptions.postalCode"
              placeholder="Code postal"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="address" label-for="Adresse">
            <b-form-textarea
              id="address"
              v-model="localOptions.address"
              rows="2"
              placeholder="Adresse..."
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label-for="IANA" label="Signature ( extension png, jpeg, jpg ) - le nom du fichier est crypté">
             <b-form-input
              @click="openUploadModal"
              v-model="localOptions.signature"
              placeholder="Choisir un fichier..."
                id="IANA"
                accept="image/jpeg, image/png, image/gif"
              />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            @click="saveSettings()"
          >
            Enregistrer
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import axios from "axios";
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BFormTextarea,
  BFormFile
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import Cleave from "vue-cleave-component";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

// eslint-disable-next-line import/no-extraneous-dependencies
import "cleave.js/dist/addons/cleave-phone.us";

export default {
  components: {
    BFormFile,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BFormTextarea,
    vSelect,
    flatPickr,
    Cleave,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  props: {
    informationData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      countryOption: ["USA", "India", "Canada"],
      localOptions: JSON.parse(JSON.stringify(this.informationData)),
      clevePhone: {
        phone: true,
        phoneRegionCode: "US",
      },
    };
  },
  methods: {
     openUploadModal() {
      window.cloudinary
        .openUploadWidget(
          { cloud_name: "dmdd546ps", upload_preset: "jhyzlocs" },
          (error, result) => {
            if (!error && result && result.event === "success") {
              console.log("Done uploading..: ", result);
              this.url = result.info.url;
              this.publicId = result.info.public_id;
              this.localOptions.signature=this.publicId 
            }
          }
        )
        .open();
    },
    resetForm() {
      this.localOptions = JSON.parse(JSON.stringify(this.informationData));
    },
    saveSettings() {
      console.log(JSON.stringify( this.localOptions));
      axios
        .put(
          `https://mtl-feeder-nodejs.onrender.com/api/users/${
            JSON.parse(localStorage.getItem("userData")).user._id
          }`,
          this.localOptions
        )
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Utilisateur bien Modifié`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Error during update`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
